import { BsPerson } from "react-icons/bs";
import Input from "@/components/input/Input";
import Select from "@/components/select/Select";

function InformationInputs({
    isRequired,
    register,
    isPending,
    errors,
    ApiError,
    watch,
    setValue,
}) {
    return (
        <>
            <div className="flex items-center justify-between gap-4 ">
                {/* FirstName */}
                <Input
                    type="text"
                    id="firstName"
                    name="firstName"
                    disabled={isPending}
                    label="الإسم الأول*"
                    icon={BsPerson}
                    register={register("firstName", {
                        ...(isRequired ? { required: isRequired } : {}),
                    })}
                    error={errors?.firstName?.message}
                />

                {/* SecondName */}
                <Input
                    type="text"
                    name="secondName"
                    id="secondName"
                    disabled={isPending}
                    label="الإسم الثاني*"
                    icon={BsPerson}
                    register={register("secondName", {
                        ...(isRequired ? { required: isRequired } : {}),
                    })}
                    error={errors?.secondName?.message}
                />
            </div>
            {/* Gender */}
            <Select
                name="gender"
                label="النوع*"
                disabled={isPending}
                setValue={setValue}
                watch={watch}
                register={register("gender", {
                    ...(isRequired ? { required: isRequired } : {}),
                })}
                error={
                    errors?.gender?.message ||
                    ApiError?.response?.data?.errors?.gender?.[0]
                }
                options={[
                    { value: "male", text: "ذكر" },
                    { value: "female", text: "انثي" },
                ]}
            />
        </>
    );
}

export default InformationInputs;
